import React, { useState, Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useAsyncError, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { Form, Dropdown } from "react-bootstrap";
import { categoryGet, categoryhideshowAxios, networkHideShowAxios, newWorkListGet } from "../../Actions/axios";
import { toast } from "react-toastify";

const CategoryList = () => {
  const navigate = useNavigate();
  const [catList, setCatList] = useState([]);

  const getcategoryGet = async () => {
    let resp = await categoryGet({
      page : 0,
      limit : Number.MAX_SAFE_INTEGER
    });
    console.log("🚀 ~ getcategoryGet ~ resp:", resp)
    if (resp?.status) {
      setCatList(resp?.data);
    }
  };

  const categoryhideshow = async (id)=>{
    let resp = await categoryhideshowAxios({_id : id })
    console.log("🚀 ~ networkHideShow ~ resp:", resp);
    if(resp?.status){
     toast.success(resp?.message);
     getcategoryGet();
    }
  }

  const columns = [
    {
      name: "S.no",
      align: "left",
      sortable: false,
      selector: (row, i) => <p>{i + 1}</p>,
    },
    {
      name: "Name",
      align: "left",
      sortable: false,
      selector: (row, i) => <p>{row?.name}</p>,
    },
    {
      name: "isVisible",
      align: "left",
      sortable: false,
      selector: (row, i) => {
        return (
          <>
            <button type="button" className="btn sitebtn" onClick={()=>categoryhideshow(row?._id)}>
              {row?.isVisible ? "HIDE" : "SHOW"}
            </button>
          </>
        );
      },
    },
    {
      name: "Edit",
      align: "left",
      sortable: false,
      selector: (row, i) => {
        return (
          <Fragment>
            <button
              className={`btn sitebtn btn-sm ${row._id}`}
              onClick={() =>
                navigate("/categoryedit", {
                  state: {
                    ...row,
                  },
                })
              }
            >
              <FaEdit />
            </button>
          </Fragment>
        );
      },
    },
  ];


  useEffect(
    () => {
      getcategoryGet();
    },
    [
      // searchtext, type, page, limit
    ]
  );
  return (
    <div className="cmslist">
      <h1 className="pagehead">Category List</h1>
      <div className="cardbox">
        <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
          <Link to="/categoryadd" className="btn sitebtn">
            Add
          </Link>
        </div>
        <div className="tablebox">
          <DataTable
            className="react-datatables"
            columns={columns}
            data={catList}
            pagination
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
          />
        </div>
      </div>
    </div>
  );
};

export default CategoryList;
